import {
  getTimelineEntryBehaviorType,
  getTimelineEntryEditTarget,
} from './timelineEntryBehavior';

const normalizeText = (value) => String(value || '').trim();

const CATEGORY_MODE_MAP = {
  medication: 'medication',
  meds: 'medication',
  medicine: 'medication',
  pill: 'medication',
  medication_change: 'medication_change',
  sleep: 'sleep',
  bedtime: 'sleep',
  food: 'food',
  meal: 'food',
  snack: 'food',
  eating: 'food',
  behavior: 'behavior',
  behaviour: 'behavior',
  incident: 'behavior',
  meltdown: 'behavior',
  trigger: 'behavior',
  activity: 'activity',
  dailyhabit: 'activity',
  habit: 'activity',
  mood: 'mood',
  bathroom: 'bathroom',
  toilet: 'bathroom',
  toileting: 'bathroom',
  diaper: 'bathroom',
  note: 'note',
  log: 'note',
  dailylog: 'note',
  generic: 'note',
  milestone: 'note',
};

const getCategoryCandidate = (entry = {}, entryConfig = null) => normalizeText(
  entryConfig?.kind
  || entryConfig?.type
  || entryConfig?.category
  || entryConfig?.label
  || entryConfig?.titlePrefix
  || entry.category
  || entry.timelineType
  || entry.type
  || entry.logCategory
  || entry.categoryLabel
  || ''
).toLowerCase();

const getStructuredEntryText = (entry = {}, entryConfig = null) => {
  const mappedMode = CATEGORY_MODE_MAP[getCategoryCandidate(entry, entryConfig)] || 'note';

  switch (mappedMode) {
    case 'medication':
      return normalizeText(
        entry.medicationDetails?.medicationName
        || entry.medicationDetails?.name
        || entry.medicationName
        || entry.medicationScheduleDose
        || entry.medicationScheduleUnit
        || entry.dose
        || entryConfig?.primaryText
        || entryConfig?.notesText
        || ''
      );
    case 'medication_change':
      return normalizeText(
        entry.medicationChangeSummary
        || entry.medicationChangeTitle
        || entry.summary
        || entry.title
        || entry.note
        || entryConfig?.primaryText
        || entryConfig?.notesText
        || ''
      );
    case 'sleep':
      return normalizeText(
        entry.sleepDetails?.notes
        || entry.sleepDetails?.quality
        || entry.sleepDetails?.disturbance
        || entry.sleepQuality
        || entry.notes
        || entryConfig?.notesText
        || ''
      );
    case 'food':
      return normalizeText(
        entry.foodDetails?.whatWasEaten
        || entry.foodDetails?.mealType
        || entry.foodDetails?.portion
        || entry.foodDetails?.reaction
        || entry.foodDetails?.notes
        || entryConfig?.primaryText
        || entryConfig?.notesText
        || ''
      );
    case 'behavior':
      return normalizeText(
        entry.incidentData?.description
        || entry.incidentData?.notes
        || entry.description
        || entry.notes
        || entry.summary
        || entry.triggerSummary
        || entryConfig?.primaryText
        || entryConfig?.notesText
        || ''
      );
    case 'activity':
      return normalizeText(
        entry.activityDetails?.activityThemeLabel
        || entry.activityDetails?.activityType
        || entry.activityDetails?.notes
        || entry.activityThemeLabel
        || entry.activityType
        || entry.activityTypes
        || entry.data?.notes
        || entry.notes
        || entry.description
        || entryConfig?.primaryText
        || entryConfig?.notesText
        || ''
      );
    case 'mood':
      return normalizeText(
        entry.moodValue
        || entry.value
        || entry.data?.level
        || entry.data?.value
        || entryConfig?.primaryText
        || entryConfig?.notesText
        || ''
      );
    case 'bathroom':
      return normalizeText(
        entry.bathroomDetails?.notes
        || entry.bathroomDetails?.type
        || entry.bathroomDetails?.status
        || entry.notes
        || entry.description
        || entryConfig?.notesText
        || ''
      );
    default:
      return normalizeText(
        entry.notes
        || entry.description
        || entry.summary
        || entry.text
        || entry.content
        || entryConfig?.notesText
        || ''
      );
  }
};

export const getEntryEditBehaviorType = getTimelineEntryBehaviorType;

export const getEntryEditMode = (entry = {}, entryConfig = null) => {
  return getTimelineEntryEditTarget(entry, entryConfig);
};

export const getEntryEditSourceText = getStructuredEntryText;
